import { depotsSelectors } from '@/entities/depots'
import { runsheetShiftTablesSelector } from '@/entities/gridTables/selectors/runsheetShiftTablesSelector'
import { runsheetUnassignedTablesSelector } from '@/entities/gridTables/selectors/runsheetUnassignedTablesSelector'
import { runsheetShiftsSelectors } from '@/entities/schedules'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsMapWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { useLeafletMapContext } from '@/shared/components/LeafletMap'
import { useAppSelector } from '@/shared/store'

import { useDrawDepots } from './libs/useDrawDepots'
import { useDrawRoutes } from './libs/useDrawRoutes'
import { useDrawShifts } from './libs/useDrawShifts'
import { useDrawUnassignedOrders } from './libs/useDrawUnassignedOrders'
import { useFlyToSelectedStop } from './libs/useFlyToSelectedStop'
import { useHistoricalTrace } from './libs/useHistoricalTrace'
import { useTrackLiveLocations } from './libs/useTrackLiveLocations'
import { useOperationMapContext } from './OperationsMapWidgetContext'

export const RunsheetMapWidgetControl: React.FC = () => {
  const { map } = useLeafletMapContext()
  const { widgetId } = useOperationMapContext()
  const mapWindowState = useAppSelector(state => widgetWindowsSelector.selectById(state, widgetId))
  const allShifts = useAppSelector(state => runsheetShiftsSelectors.selectAll(state))
  const activeGroupId = useAppSelector(state => state.userInterface.activeGroupId)
  const depots = useAppSelector((state) => depotsSelectors.selectAll(state)).filter((depot) => depot.groupId === activeGroupId)
  const lastSelectedStopId = useAppSelector(state => state.userInterface.lastSelectedStopId)


  // Get the selected shift ids from the widget window state
  const selectedShiftIds = (mapWindowState as OperationsMapWidgetWindow)?.shiftIds || []
  const relevantShifts = allShifts.filter((shift) => selectedShiftIds.includes(shift.id))
  const shiftTableEntities = useAppSelector(state => runsheetShiftTablesSelector.selectEntities(state))
  const relevantShiftTables = relevantShifts.map((shift) => shiftTableEntities[shift.id])

  // Get the selected unassigned scenario ids from the widget window state
  const selectedUnassignedRunsheetIds = (mapWindowState as OperationsMapWidgetWindow)?.unassignedScheduleIds || []
  const unassignedTableEntities = useAppSelector(state => runsheetUnassignedTablesSelector.selectEntities(state))
  const relevantUnassignedTables = selectedUnassignedRunsheetIds.map((runsheetId) => unassignedTableEntities[runsheetId])
  
  // Get the selected live location shift ids fro mthe widget window state
  const selectedLiveLocationShiftIds = (mapWindowState as OperationsMapWidgetWindow)?.liveLocationShiftIds || []

  useTrackLiveLocations({
    map,
    selectedShiftIds: selectedLiveLocationShiftIds,
  })

  useDrawShifts({
    map,
    shiftTables: relevantShiftTables,
  })

  useDrawUnassignedOrders({
    map,
    unassignedTables: relevantUnassignedTables,
  })

  useDrawDepots({
    map,
    depots,
  })

  useDrawRoutes({
    map,
    selectedShiftIds,
    allShifts,
    currentScreen: 'runsheet',
  })

  useFlyToSelectedStop({
    map,
    stopId: lastSelectedStopId,
    shiftTables: relevantShiftTables,
    currentScreen: 'runsheet',
  })

  useHistoricalTrace()
  
  return null
}